// extracted by mini-css-extract-plugin
module.exports = {"customMessage":"CopyText_customMessage__jtrUt"};